import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { RootState } from '../../store/store';
import { IListResponse } from '../../configs/constants';
import { queryParams } from '../../utils/query-string';
import { IParams, IHistory } from './histories';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 2 });

export const historyApi = createApi({
  reducerPath: 'historyApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: ['History'],
  endpoints: (builder) => ({
    getHistories: builder.query<
      IListResponse<IHistory>,
      { page: number; pageSize: number; keyword?: string }
    >({
      query: ({ page, pageSize, keyword }) => {
        const params: IParams = {
          take: pageSize,
          skip: (page - 1) * pageSize,
        };
        if (keyword) params.keyword = keyword;
        return {
          url: `histories?${queryParams(params)}`,
          method: 'GET',
        };
      },
      providesTags: ['History'],
    }),
  }),
});

export const { useGetHistoriesQuery } = historyApi;
